<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="all">
      <div class="top">
        <el-tabs v-model="activeName"
                 @tab-click="handleClick1">
          <el-tab-pane label="待认证"
                       name="first">
            <toBeCertified></toBeCertified>
          </el-tab-pane>
          <el-tab-pane label="全部"
                       name="second">
            <all></all>
          </el-tab-pane>
          <el-tab-pane label="未认证"
                       name="third">
            <notcertified></notcertified>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-card>
</template>

<script>
import toBeCertified from './to-be-certified'
import all from './all'
import notcertified from './not-certified'

export default {
  data () {
    return {
      dataForm: {
        creatorName: ''
      },
      activeName: 'first'
    }
  },
  methods: {
    handleClick1 (tab) {
    }
  },
  components: {
    toBeCertified,
    all,
    notcertified
  }
}
</script>
